import { initializeApp } from "firebase/app";
// Medición apagada a pedido del CM (2026-11-01) mientras arma la nueva. Para encenderla, quitar el
// comentario de esta línea, de `const analytics` y de `analytics` en el export. Sin getAnalytics,
// el measurementId de la configuración no mide nada.
// import { getAnalytics } from "firebase/analytics";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getMessaging } from "firebase/messaging";

// Desarrollo local contra los emuladores (firebase.emulador.json, `npm run emuladores`): con
// VUE_APP_USE_EMULATORS=true la app usa un proyecto de demostración, así que nada de lo que haga
// puede tocar producción: un servicio que no esté emulado falla en vez de ir al proyecto real.
const usarEmuladores = process.env.NODE_ENV === "development" && process.env.VUE_APP_USE_EMULATORS === "true";
const PROYECTO_EMULADORES = "demo-riskmannsofu";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: usarEmuladores ? PROYECTO_EMULADORES : process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

// const analytics = getAnalytics(firebaseApp);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const rtdb = getDatabase(firebaseApp);
const storage = getStorage(firebaseApp);
const functions = getFunctions(firebaseApp, "us-central1");
const messaging = getMessaging(firebaseApp);

if (usarEmuladores) {
  // Puertos de firebase.emulador.json
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "localhost", 8081);
  connectDatabaseEmulator(rtdb, "localhost", 9000);
  connectStorageEmulator(storage, "localhost", 9199);
  connectFunctionsEmulator(functions, "localhost", 5001);
} else if (process.env.NODE_ENV === "development" && process.env.VUE_APP_USE_FUNCTIONS_EMULATOR === "true") {
  // (Opcional) Solo el emulador de Functions, contra los datos reales del proyecto
  connectFunctionsEmulator(functions, "localhost", 5001);
}

// Algunos seleccionables consultan Firestore por REST (runQuery, ver apis en el store) y no por el
// SDK: con emuladores esas consultas también van al emulador y no al proyecto real.
const urlConsultasFirestore = usarEmuladores
  ? `http://localhost:8081/v1/projects/${PROYECTO_EMULADORES}/databases/(default)/documents:runQuery`
  : "https://firestore.googleapis.com/v1/projects/riskmannsofu/databases/(default)/documents:runQuery";

export {
  firebaseApp,
  auth,
  db,
  rtdb,
  storage,
  functions,
  // analytics,
  messaging,
  urlConsultasFirestore,
};
